import React from 'react';
import { Button, Container, Header, Icon, Segment } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';

const clientId = '5e9623791b63ebfa0540ce6d4e4de91e';
const redirectUrlHost = window.location.protocol + '//' + window.location.host;
const kakaoRedirectUrl = redirectUrlHost + '/login/kakao';

const handleKakaoLogin = () => {
  window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${kakaoRedirectUrl}`;
};

const LoginPage = () => {
  const navigate = useNavigate();

  const handleAdminLoginClick = () => {
    navigate('/login/form');
  };

  return (
    <Container text style={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
      <Segment raised style={{ width: '100%' }}>
        <Header as="h1" textAlign="center">
          Noobook 관리자
          <Header.Subheader>관리자 전용 로그인 페이지</Header.Subheader>
        </Header>
        <Button
          primary
          fluid
          size="large"
          style={{ marginTop: 24 }}
          onClick={handleAdminLoginClick}
        >
          <Icon name="user" />
          관리자 계정으로 로그인
        </Button>
        <Header as="h4" textAlign="center" style={{ marginTop: 24, marginBottom: 16 }}>
          또는
        </Header>
        <Button
          color="yellow"
          fluid
          size="large"
          onClick={handleKakaoLogin}
        >
          <Icon name="comment" />
          카카오로 로그인
        </Button>
      </Segment>
    </Container>
  );
};

export default LoginPage;
